import axios from './axiosConfig';
import { API_URL, BASE_URL } from './config';

const hk = (id) => `${API_URL}/${id}`;

export const getHousekeepers = () => axios.get(API_URL);
export const getHousekeeperById = (id) => axios.get(hk(id));
export const createHousekeeper = (data) => axios.post(API_URL, data);
export const updateHousekeeper = (id, data) => axios.put(hk(id), data);
export const deleteHousekeeper = (id) => axios.delete(hk(id));

export const updateResumeStatus = (id, status) =>
  axios.put(`${hk(id)}/resume-status?status=${status}`);

export const idcardOcr = (id, imageUrl) =>
  axios.post(`${hk(id)}/idcard-ocr?image_url=${encodeURIComponent(imageUrl)}`);

export const idcardOcrTemp = (imageUrl) =>
  axios.post(`${API_URL}/idcard-ocr-temp?image_url=${encodeURIComponent(imageUrl)}`, null, { timeout: 60000 });

export const uploadIdcardImage = (id, imageUrl, side) =>
  axios.post(`${hk(id)}/idcard-image?image_url=${encodeURIComponent(imageUrl)}&side=${side}`);

export const uploadPhoto = (id, photoUrl) =>
  axios.post(`${hk(id)}/photo?photo_url=${encodeURIComponent(photoUrl)}`);

export const getHousekeeperExt = (id) => axios.get(`${hk(id)}/ext`);

export const saveChatText = (id, text) =>
  axios.post(`${hk(id)}/chat-text?text=${encodeURIComponent(text)}`);

export const updateAbilitySalary = (id, salary) =>
  axios.put(`${hk(id)}/ability-salary?ability_salary=${salary}`);

export const uploadAudioRecord = (id, audioUrl, originalFilename) =>
  axios.post(`${hk(id)}/audio-record?audio_url=${encodeURIComponent(audioUrl)}&original_filename=${encodeURIComponent(originalFilename || '录音')}`);

export const uploadChatRecordWithTranscription = (id, imageUrl) =>
  axios.post(`${hk(id)}/chat-record?image_url=${encodeURIComponent(imageUrl)}&transcribe=true`);

export const uploadWorkImage = (id, imageUrl) =>
  axios.post(`${hk(id)}/work-image?image_url=${encodeURIComponent(imageUrl)}`);

export const uploadCookImage = (id, imageUrl) =>
  axios.post(`${hk(id)}/cook-image?image_url=${encodeURIComponent(imageUrl)}`);

export const uploadCertificateImage = (id, imageUrl) =>
  axios.post(`${hk(id)}/certificate-image?image_url=${encodeURIComponent(imageUrl)}`);

export const uploadNannyCert = (id, imageUrl) =>
  axios.post(`${hk(id)}/nanny-cert?image_url=${encodeURIComponent(imageUrl)}`);

export const deleteNannyCert = (id, imageUrl) =>
  axios.delete(`${hk(id)}/delete-nanny-cert?image_url=${encodeURIComponent(imageUrl)}`);

export const uploadBankCardImageWithExtraction = (id, imageUrl) =>
  axios.post(`${hk(id)}/bank-card-image-with-extraction?image_url=${encodeURIComponent(imageUrl)}&extract_salary=true`);

export const uploadResume = (id, formData) =>
  axios.post(`${hk(id)}/upload-resume`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }, timeout: 180000
  });

export const uploadResumeTemp = (formData) =>
  axios.post(`${API_URL}/upload-resume-temp`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }, timeout: 180000
  });

export const deleteAudioRecord = (id, audioUrl) =>
  axios.delete(`${hk(id)}/delete-audio?audio_url=${encodeURIComponent(audioUrl)}`);

export const deleteChatRecord = (id, imageUrl) =>
  axios.delete(`${hk(id)}/delete-chat-record?image_url=${encodeURIComponent(imageUrl)}`);

export const deleteWorkImage = (id, imageUrl) =>
  axios.delete(`${hk(id)}/delete-work-image?image_url=${encodeURIComponent(imageUrl)}`);

export const deleteCookImage = (id, imageUrl) =>
  axios.delete(`${hk(id)}/delete-cook-image?image_url=${encodeURIComponent(imageUrl)}`);

export const deleteCertificateImage = (id, imageUrl) =>
  axios.delete(`${hk(id)}/delete-certificate-image?image_url=${encodeURIComponent(imageUrl)}`);

export const deleteResume = (id, resumeUrl) =>
  axios.delete(`${hk(id)}/delete-resume?resume_url=${encodeURIComponent(resumeUrl)}`);

export const deleteTempResume = (resumeUrl) =>
  axios.delete(`${API_URL}/delete-temp-resume?resume_url=${encodeURIComponent(resumeUrl)}`);

export const generateSummary = (id, imageUrl) =>
  axios.post(`${hk(id)}/generate-summary?image_url=${encodeURIComponent(imageUrl)}`, null, { timeout: 180000 });

export const generateAudioSummary = (id, audioUrl) =>
  axios.post(`${hk(id)}/generate-audio-summary?audio_url=${encodeURIComponent(audioUrl)}`, null, { timeout: 180000 });

// Assessment review APIs
export const getHousekeeperAssessment = (id) =>
  axios.get(`${hk(id)}/assessment`);

export const getAssessmentDetails = (id) =>
  axios.get(`${hk(id)}/assessment-details`);

export const initAssessmentDetails = (id) =>
  axios.post(`${hk(id)}/init-assessment-details`);

export const updateAssessmentReview = (id, data) =>
  axios.put(`${hk(id)}/assessment-review`, data);

// Assessment criteria (V2)
export const getAssessmentCriteria = (role) =>
  axios.get(`${API_URL.replace('/api/housekeepers', '/api')}/assessment-criteria${role ? `?role=${encodeURIComponent(role)}` : ''}`);

// Assessment role config (V2)
export const getAssessmentRoleConfig = (role) =>
  axios.get(`${API_URL.replace('/api/housekeepers', '/api')}/assessment-role-config?role=${encodeURIComponent(role || '育婴师')}`);

// Resume publish & share APIs
export const publishResume = (id, expireDays) =>
  axios.post(`${hk(id)}/publish-resume`, { housekeeper_id: id, expire_days: expireDays });

export const getPublishList = (id) =>
  axios.get(`${hk(id)}/publish-list`);

export const getShareResume = (shareToken) =>
  axios.get(`${API_URL.replace('/api/housekeepers', '/api')}/share/${shareToken}`);

// WeChat JS-SDK config
export const getWechatJssdkConfig = (url) =>
  axios.get(`${API_URL.replace('/api/housekeepers', '/api')}/wechat/jssdk-config?url=${encodeURIComponent(url)}`);

// Practical video APIs
const PRACTICAL_URL = `${BASE_URL}/api/practical`;

export const getPracticalList = (housekeeperId) =>
  axios.get(`${PRACTICAL_URL}/list/${housekeeperId}`);

export const getPracticalPresignedUrl = (data) =>
  axios.post(`${PRACTICAL_URL}/presigned-url`, data);

export const createPractical = (data) =>
  axios.post(`${PRACTICAL_URL}/create`, data);

export const updatePracticalScore = (practicalId, score) =>
  axios.put(`${PRACTICAL_URL}/${practicalId}/score`, { score });

export const deletePractical = (practicalId) =>
  axios.delete(`${PRACTICAL_URL}/${practicalId}`);

// Admin assessment category management APIs
const ADMIN_URL = `${BASE_URL}/api/admin`;

export const adminApi = {
  getLevel1Categories: (type) => axios.get(`${ADMIN_URL}/level1-categories?type=${encodeURIComponent(type)}`),
  createLevel1Category: (data) => axios.post(`${ADMIN_URL}/level1-categories`, data),
  updateLevel1Category: (id, data) => axios.put(`${ADMIN_URL}/level1-categories/${id}`, data),
  deleteLevel1Category: (id) => axios.delete(`${ADMIN_URL}/level1-categories/${id}`),

  getLevel2Categories: (type) => axios.get(`${ADMIN_URL}/level2-categories?type=${encodeURIComponent(type)}`),
  createLevel2Category: (data) => axios.post(`${ADMIN_URL}/level2-categories`, data),
  updateLevel2Category: (id, data) => axios.put(`${ADMIN_URL}/level2-categories/${id}`, data),
  deleteLevel2Category: (id) => axios.delete(`${ADMIN_URL}/level2-categories/${id}`),

  getLevel3Categories: (type) => axios.get(`${ADMIN_URL}/level3-categories?type=${encodeURIComponent(type)}`),
  createLevel3Category: (data) => axios.post(`${ADMIN_URL}/level3-categories`, data),
  updateLevel3Category: (id, data) => axios.put(`${ADMIN_URL}/level3-categories/${id}`, data),
  deleteLevel3Category: (id) => axios.delete(`${ADMIN_URL}/level3-categories/${id}`),

  getCategoryTree: (type) => axios.get(`${ADMIN_URL}/category-tree?type=${encodeURIComponent(type)}`),
  initDefaultTemplates: (type) => axios.post(`${ADMIN_URL}/init-default-templates`, { type }),
};